import { ButtonSecondary } from '@/shared/ui/button';
import styles from './index.module.sass';
import { Card } from '@@/common/components/offer-card';
import { memo, useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import {
  $offersData,
  $offersDataStatus,
  fetchBuyerOffersListFx,
  setOffers,
  updateOfferFx,
} from '@/modules/seller-account/store/offers.store';
import {
  $buyersData,
  $singleBuyerData,
  fetchBuyerByIdFx,
} from '@/modules/seller-account/store/buyers.store';
import { BuyerInstance, OfferInstance } from '@/modules/seller-account/ts';
import { Spin } from 'antd';
import md5 from 'md5';
import { handleSwitch } from '@/modules/seller-account/functions/handle-switch-offer.function';
import { handleDelete } from '@/modules/seller-account/functions/handle-delete-offer.function';

export const OffersTab = memo(
  ({
    isExternal,
    offersSort,
    setShowOfferModal,
    isBuyerEnabled,
    reloadSidebarFx,
  }: IOffersTab) => {
    const [displayTooltip, setDisplayTooltip] = useState(-1);
    const buyerInfo = useStore($singleBuyerData);
    const allBuyers = useStore($buyersData);
    const dataLoading = useStore($offersDataStatus);
    const data = useStore($offersData);

    const offsetMinutes = new Date().getTimezoneOffset();

    const refetchOffersList = () =>
      fetchBuyerOffersListFx({
        id: buyerInfo?.id as any,
        md5: buyerInfo?.type === 'external' ? md5(buyerInfo?.company_name) : undefined,
        disableLoadingStatus: true,
      });

    const compareFoo = (offersSort: IOffersSort) => {
      const foosSet = {
        creationDate: (a: OfferInstance, b: OfferInstance) => {
          const fDate = new Date(a.created_at);
          const sDate = new Date(b.created_at);
          return offersSort.order === 'desc'
            ? fDate > sDate
              ? -1
              : 1
            : fDate < sDate
            ? -1
            : 1;
        },
        deadline: (a: OfferInstance, b: OfferInstance) => {
          const fDate = new Date(a.expiration_offer);
          const sDate = new Date(b.expiration_offer);
          return offersSort.order === 'desc'
            ? fDate > sDate
              ? -1
              : 1
            : fDate < sDate
            ? -1
            : 1;
        },
        price: (a: OfferInstance, b: OfferInstance) => {
          const f = Number(a.price);
          const s = Number(b.price);
          return offersSort.order === 'desc' ? (f > s ? -1 : 1) : f < s ? -1 : 1;
        },
        classN: (a: OfferInstance, b: OfferInstance) => {
          const f = Number(a.wheat_class);
          const s = Number(b.wheat_class);
          return offersSort.order === 'desc' ? (f > s ? -1 : 1) : f < s ? -1 : 1;
        },
        editedDate: (a: OfferInstance, b: OfferInstance) => {
          const f = new Date(a.updated_at).getTime();
          const s = new Date(b.updated_at).getTime();
          return offersSort.order === 'desc' ? (f > s ? -1 : 1) : f < s ? -1 : 1;
        },
      };

      const key = offersSort.param.find((item) => item.active);

      // @ts-ignore
      return key ? foosSet[key.val] : foosSet.creationDate;
    };

    useEffect(() => {
      const preparedData = data?.sort(compareFoo(offersSort));
      setOffers(preparedData);
    }, [offersSort, data, dataLoading, buyerInfo?.id]);

    return (
      <>
      <div className={styles.top}>
      <span className={styles.attentionOffers}>
          {' '}
          <b style={{ color: '#F1898E' }}>ВАЖНО:</b> Минимальный срок действия
          предложения покупателя равняется 5 минутам. После чего все сделки, по данным
          предложениям, становятся недействительными.
        </span>
        {!isExternal && (
          <ButtonSecondary
            className={styles.button}
            label={'добавить новое предложение покупателя'}
            onClick={() => setShowOfferModal(true)}
          />
        )}
      </div>
      
      <div className={styles.root}>
        <div className={styles.offersBlock}>
          {dataLoading.loading && <Spin className={styles.loader} size="large" />}
          {data && !dataLoading.loading && Array.isArray(data) && data?.length > 0 ? (
            data
              ?.sort(compareFoo(offersSort))
              .map(
                (
                  {
                    price,
                    gluten,
                    idk,
                    clop,
                    cp,
                    protein,
                    humidity,
                    weed,
                    nature,
                    wheat_different_type,
                    wheat_type,
                    wheat_class,
                    admixture_other_cereals,
                    expiration_offer,
                    id,
                    year,
                    buyer_id,
                    enabled,
                    pickup,
                    updated_at,
                  }: OfferInstance,
                  i: number,
                ) => (
                  <Card
                    key={i}
                    displayTooltip={displayTooltip}
                    setShowOfferModal={setShowOfferModal}
                    setDisplayTooltip={setDisplayTooltip}
                    title={data[i]['class']}
                    editable={!isExternal}
                    data={{
                      id: Number(id),
                      buyer_id,
                      expiration_offer: new Date(`${expiration_offer} UTC`).toString(),
                      price,
                      gluten,
                      idk,
                      clop,
                      protein,
                      cp,
                      nature,
                      humidity,
                      weed,
                      admixture_other_cereals,
                      wheat_different_type,
                      wheat_type,
                      wheat_class,
                      year,
                      enabled,
                      pickup,
                    }}
                    onExpiryAction={async (id) => {
                      //setOffers(data.map(item => item.id === id ? { ...item, enabled: false } : item));
                      const actualOffers = data
                        .filter((item) => item.id !== id)
                        .filter((item) => item.enabled);
                      //if(actualOffers.length < 1) setLocalDisabledBuyer(buyerInfo?.id as any);
                    }}
                    handleSwitch={async (val: boolean, editable: boolean) =>
                      await handleSwitch(
                        Number(id),
                        val,
                        editable,
                        buyerInfo,
                        isBuyerEnabled,
                        {
                          fetchBuyerByIdFx,
                          updateOfferFx,
                          refetch: refetchOffersList,
                          reloadSidebarFx,
                        },
                      )
                    }
                    handleSwitchPickup={async (editable: boolean) =>
                      await handleSwitch(
                        Number(id),
                        !pickup,
                        editable,
                        buyerInfo,
                        isBuyerEnabled,
                        {
                          fetchBuyerByIdFx,
                          updateOfferFx,
                          refetch: refetchOffersList,
                          reloadSidebarFx,
                        },
                        true,
                        {
                          id: Number(id),
                          buyer_id,
                          expiration_offer: String(
                            new Date(expiration_offer).getTime() / 1000 -
                              offsetMinutes * 60,
                          ),
                          price,
                          gluten,
                          idk,
                          clop,
                          protein,
                          cp,
                          nature,
                          humidity,
                          weed,
                          admixture_other_cereals,
                          wheat_different_type,
                          wheat_type,
                          wheat_class,
                          year,
                          enabled,
                          pickup: !pickup,
                          updated_at,
                        },
                      )
                    }
                    handleDelete={async () => {
                      await handleDelete({
                        type: buyerInfo?.type as any,
                        id: Number(id),
                        // setDisplayTooltip,
                        company_name: buyerInfo?.company_name as any,
                      });
                      await refetchOffersList();
                      await reloadSidebarFx();
                      if (Array.isArray(data) && data.length === 1) {

                      }
                    }}
                    enabled={0}
                  />
                ),
              )
          ) : (
            <div className={styles.placeholder}>
              <span>Покупатель пока не разместил свои предложения</span>
            </div>
          )}
        </div>
      </div>
      </>
    );
  },
);

interface IOffersTab {
  showOfferModal: boolean;
  setShowOfferModal: (val: boolean) => void;
  isExternal: boolean;
  isBuyerEnabled: boolean;
  reloadSidebarFx: () => Promise<BuyerInstance[] | undefined>;
  offersSort: IOffersSort;
}

interface IOffersSort {
  order: 'asc' | 'desc' | string;
  param: { label: string; val: string; active: boolean }[];
}
